import React from "react";
import "./App.scss";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import store, { persistor, history } from "./store";
import { Router, Route, Switch } from "react-router-dom";
import Login from "./components/auth/login";
import Register from "./components/auth/register";
import Home from "./components/home/home";
import OTP from "./components/auth/otp";
import ProtectedRoute from "./protectedRoute";
import ForgotUserId from "./components/auth/forgotUserId";
import ForgotPassword from "./components/auth/forgotPassword";
import ResetPassword from "./components/auth/resetPassword";
import TNDC from "./components/auth/tndc";
import Faqs from "./components/auth/Faqs";
import DistributorEmpanellement from "./components/auth/distributorEmpanellement";
import GenerateARNLink from "./components/auth/arnLink";
import Bankdetails from "./components/auth/bankdetails";
import NomineeDetails from "./components/auth/dnomineeDetails";
import commonArnLink from "./components/auth/commonArnLink";
import Confirmation from "./components/auth/confirmation";
import BajajCompanies from "./components/auth/bajajcompanies"

const PUBLIC_URL = process.env.PUBLIC_URL || "/";

const Routes = () => {
  return (
    <Router history={history} basename={PUBLIC_URL}>
      <Switch>
        <Route path={`/login`} component={Login} />
        <Route path={`/otp`} component={OTP} />
        <Route path={`/forgot-userid`} component={ForgotUserId} />
        <Route path={`/terms-conditions`} component={TNDC} />
        <Route
          path={`/distributor-empanellement/bank-details`}
          component={Bankdetails}
          exact
        />
        <Route
          path={`/distributor-empanellement`}
          component={DistributorEmpanellement}
          exact
        />
        <Route
          path={`/distributor-empanellement/confirmation`}
          component={Confirmation}
          exact
        />

        <Route
          path={`/distributor-empanellement/nominee-details`}
          component={NomineeDetails}
          exact
        />
         <Route
          path={`/distributor-empanellement/Bajaj-entities`}
          component={BajajCompanies}
          exact
        />
        <Route path={`/generate-arn-link`} component={GenerateARNLink} />
        <Route path={`/common-arn-link`} component={commonArnLink} />
        <Route path={`/Enach-Faq's`} component={Faqs} />
        <Route path={`/forgot-password`} component={ForgotPassword} />
        <Route path={`/reset-password`} component={ResetPassword} />
        <Route path={`/register`} component={Register} />
        <ProtectedRoute path={`/`} component={Home} />
      </Switch>
    </Router>
  );
};

function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <Routes />
      </PersistGate>
    </Provider>
  );
}

export default App;
